module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/cn/CREW_BOOK_NATIONAL_italy_cn.3bec3c48.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/cn/CREW_BOOK_NATIONAL_italy_cn.png
// module id = 1210
// module chunks = 16